module.exports = __webpack_public_path__ + "static/img/introduction.15cc18a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/introduction.png
// module id = AE9A
// module chunks = 1